module.exports = __webpack_public_path__ + "media/images/icons/filled/profile-ef24b5bc1c302b107e830e8daecb8b0d.svg";